import { Body1, Button, Spinner, Subtitle1 } from "@fluentui/react-components";
import React from "react";
import { useStyles } from "./SessionExpiredOverlay.styles";

interface SessionExpiredOverlayProps {
  isAuthenticating: boolean;
  onSignIn: () => void;
}

export const SessionExpiredOverlay: React.FC<SessionExpiredOverlayProps> = ({ isAuthenticating, onSignIn }) => {
  const styles = useStyles();

  return (
    <div className={styles.root} role="alertdialog" aria-label="Session Expired">
      <div className={styles.card}>
        <Subtitle1>Session Expired</Subtitle1>
        <Body1>Your session has expired. Please sign in again to continue.</Body1>
        <div className={styles.actions}>
          <Button appearance="primary" onClick={onSignIn} disabled={isAuthenticating}>
            {isAuthenticating ? <Spinner size="tiny" /> : "Sign In"}
          </Button>
        </div>
      </div>
    </div>
  );
};
